import { render, staticRenderFns } from "./login.vue?vue&type=template&id=b99bff04&scoped=true&"
import script from "./login.vue?vue&type=script&lang=js&"
export * from "./login.vue?vue&type=script&lang=js&"
import style0 from "./login.vue?vue&type=style&index=0&id=b99bff04&lang=less&scoped=true&"
import style1 from "../../assets/css/index.css?vue&type=style&index=1&id=b99bff04&scoped=true&lang=css&"
import style2 from "../../assets/css/common.css?vue&type=style&index=2&id=b99bff04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99bff04",
  null
  
)

export default component.exports